import * as React from "react"

import Layout from "../components/layout"
import Head from '../components/head';

const Exhibitions = () => {
  return (
    <Layout>
      <div>
        <main>
          <Head title="Ausstellungen" />

          <div className="">
            <div className="flex">
              <div className="w-48 pb-6">
                <div className="mb-1 text-xl font-serif">1985</div>
                <span>Lübeck</span>
              </div>
              <div className="pt-1 pb-4 pl-5">Café Art</div>
            </div>

            <div className="flex">
              <div className="w-48 pt-5 pb-6">
                <div className="mb-1 text-xl font-serif">1988</div>
                <span>Berlin</span>
              </div>
              <div className="pt-6 pb-4 pl-5">Stodiek</div>
            </div>

            <div className="flex">
              <div className="w-48 pt-5 pb-6">
                <div className="mb-1 text-xl font-serif">1991</div>
                <span>Berlin</span>
              </div>
              <div className="pt-6 pb-4 pl-5">Böttcher Immobilien KG</div>
            </div>

            <div className="flex">
              <div className="w-48 pt-5 pb-6">
                <div className="mb-1 text-xl font-serif">1991</div>
                <span>Gelsenkirchen</span>
              </div>
              <div className="pt-6 pb-4 pl-5">Traumfabrik</div>
            </div>

            <div className="flex">
              <div className="w-48 pt-5 pb-6">
                <div className="mb-1 text-xl font-serif">1994</div>
                <span>Berlin</span>
              </div>
              <div className="pt-6 pb-4 pl-5">Apostel-Paulus-Kirche</div>
            </div>
          </div>

          <h2 className="inline-block mt-8 mb-6 text-4xl border-b-2 border-gray-300">Skulpturen</h2>

          <div className="">
            <div className="flex">
              <div className="w-48 pt-5 pb-6">
                <div className="mb-1 text-xl font-serif">2014</div>
                <span>Berlin</span>
              </div>
              <div className="pt-6 pb-4 pl-5">Garnisonkirche (Gemeinschaftsausstellung)</div>
            </div>
          </div>
        </main>
      </div>
    </Layout>
  )
}

export default Exhibitions
